import {BaseTerms} from "../../infrastructure/models/base-terms";

export class OddsByWidgetTerms extends BaseTerms {

}
